<script setup lang="ts">
import { computed } from 'vue';
import { CompromissoForm } from '~/lib/fw';
import { useAuthenticationStore } from '~/stores/authenticationStore';

interface Props {
  compromisso?: any;
  fluxo?: any;
}

const props = defineProps<Props>();
const emit = defineEmits(['close']);

const authenticationStore = useAuthenticationStore();
const buttonsDisabled = computed(() => {
  return authenticationStore.user!.id !== props.compromisso.responsavelCodigo;
});
</script>

<template>
  <CompromissoForm
    action="compromisso-responsavel/cumprir-compromisso-responsavel"
    :compromisso-codigos="props.compromisso ? [props.compromisso.codigo] : []"
    :wait-for-result="true"
    :submit-button-disabled="buttonsDisabled"
    :devolver-button-visible="true"
    :devolver-button-disabled="buttonsDisabled"
    :show-upload-files="true"
    @close="() => emit('close')"
  >
    <template #form="{ model }">
      <a-form-item
        label="Observação"
        name="observacao"
        :rules="[
          {
            message: 'Observação é obrigatório',
            required: true,
          },
        ]"
      >
        <a-textarea v-model:value="model.observacao" :rows="4" />
      </a-form-item>
    </template>
  </CompromissoForm>
</template>
